import { bind, remove, game, role, packetsStatus, apply } from "@/apis/packet";
import { sort_ASCII } from "@/libs/utils";

const state = {
  tip_flag: false,
  tip_title: "",
  tip_info: null,
  userInfo: "",
  roleInfo: ""
};

const mutations = {
  SHOW_TIP(state, obj) {
    state.tip_flag = true;
    state = Object.assign(state, obj);
  },
  HIDDEN_TIP(state) {
    state.tip_flag = false;
    state.tip_title = "";
    state.tip_info = null;
  },
  CHANGE_USERINFO(state, obj) {
    state = Object.assign(state, obj);
  },
  CLEAR_USERINFO_ID(state) {
    state.userInfo.user_id = "";
  },
  CHANGE_ROLEINFO(state, obj) {
    state = Object.assign(state, obj);
  },
  CLEAR_ROLEINFO(state) {
    state.roleInfo = "";
  },
  CHANGE_USER_STATUS(state, status) {
    state.userInfo.status = status;
  }
};

const actions = {
  async userBind({ commit }, data) {
    const r = await bind(data);
    if (r.ret === 1) commit("CHANGE_USER_STATUS", r.content.status);
    return r;
  },
  async userRemove({ commit }, data) {
    const r = await remove(data);
    if (r.ret === 1) commit("CHANGE_USER_STATUS", r.content.status);
    return r;
  },
  async getGame({ rootState }) {
    const { open_id } = rootState.packet.userInfo;
    const data = {
      open_id: open_id
    };
    const r = await game({
      ...data,
      sign: sort_ASCII(data)
     });
    return r;
  },
  async getRole({ rootState }, appkey) {
    const { open_id } = rootState.packet.userInfo;
    const data = {
      open_id: open_id,
      appkey: appkey
    };
    console.log(appkey);
    const r = await role({
      ...data,
      sign: sort_ASCII(data)
     });
    return r;
  },
  async getPacketsStatus({ rootState }) {
    const data = {
      open_id: rootState.packet.userInfo.open_id,
      appkey: rootState.packet.roleInfo.appkey,
      server_num: rootState.packet.roleInfo.server_num,
      role_id: rootState.packet.roleInfo.role_id
    };
    const r = await packetsStatus({
      ...data,
      sign: sort_ASCII(data)
    });
    return r;
  },
  async toApply({ rootState }, turn_n) {
    const data = {
      open_id: rootState.packet.userInfo.open_id,
      appkey: rootState.packet.roleInfo.appkey,
      server_num: rootState.packet.roleInfo.server_num,
      role_id: rootState.packet.roleInfo.role_id,
      turn_n: turn_n
    };
    const r = await apply({
      ...data,
      sign: sort_ASCII(data)
    });
    return r;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
